import * as React from "react";
import { forwardRef } from "react";
const SvgDotdotdot = (props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    ref={ref}
    {...props}
  >
    <circle cx={50} cy={50} r={10} />
    <circle cx={90} cy={50} r={10} />
    <circle cx={10} cy={50} r={10} />
  </svg>
);
const ForwardRef = forwardRef(SvgDotdotdot);
export default ForwardRef;
